<template>
  <!-- :class="{ 'drag-over': isDragOver }" -->
  <div class="galeria-imagenes"
      @dragover.prevent="onDragOver"
      @dragenter.prevent="onDragEnter" 
      @dragleave="onDragLeave"
      @drop.prevent="onDrop">

      <div v-if="isDragOver && !agregandoImagenes" 
        class="drag-overlay">
      <!-- <i class="fa fa-plus fa-2x"></i> -->
      <p>Suelte aquí el o los archivos adjuntos</p>
    </div>      
    <b-row >
      <b-col cols="12">
        <div class="subtitulo">
          <label>Adjuntos</label>

          <b-dropdown
              v-if="!agregandoImagenes"
              variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-plus"></i>
            </template>
            <b-dropdown-item
                @click="agregarImagen">
                <i class="fa fa-plus"></i>Agregar Imagen</b-dropdown-item>
            <b-dropdown-item
                @click="addLink">
                <i class="fa fa-plus"></i>Agregar Link</b-dropdown-item>
          </b-dropdown>

          <!-- <i class="fa fa-plus"
            id="add-imagen"
            v-if="!agregandoImagenes"
            @click.prevent="agregarImagen">
          </i> -->
        </div>

        <image-uploader
          v-if="agregandoImagenes"
          :debug="0"
          :maxWidth="1024"
          :maxHeight="2048"
          :quality="0.7"
          :autoRotate=false
          outputFormat="verbose"
          :preview=false
          :multiple=true
          :className="['fileinput', { 'fileinput--loaded' : true }]"
          :capture="true"
          accept=".jpg,.png,.jpeg,.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.zip,.rar,.ai,.psd"
          doNotResize="['gif', 'svg', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'zip', 'rar', 'ai', 'psd']"
          @onUpload="uploadingImage"
          @input="setImage"
          @inputNoResize="setImageNoResize"
          @cancel="cancelarAgregarImagen">
        </image-uploader>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="4" v-for="imagen in imagenes" :key="imagen.id">
        <b-card no-header class="galeria-imagen">
          <template v-if="isImagen(imagen.fileName)">
            <b-img fluid
              @click="consultarImagen(imagen.url)"
              :src="imagen.url"></b-img>
          </template>
          <template v-if="isPDF(imagen.fileName)">
            <div class="galeria-pdf">
              <div @click="consultarPDF(imagen)">
                <pdf 
                  :src="imagen.url"
                  :page="1"
                  :scale="0.8"/>
              </div>
            </div>
          </template>
          <template v-if="isWord(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <template v-if="isPowerPoint(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <template v-if="isExcel(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <template v-if="isOtro(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <div class="titulo">
            <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
          </div>
          <div class="footer">
            <b-button size="sm" variant="danger" class="footer-button" 
              @click.prevent="borrarImagen(imagen.id)">Borrar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="4" v-for="link in links" :key="link.id">
        <b-card no-header class="galeria-imagen">
          <div class="galeria-doc">
            <i class="fa fa-external-link fa-2x" @click="copyToClipboard(link.link)"></i>
            <label @click="copyToClipboard(link.link)">{{ link.link }}</label>
          </div>
          <div class="titulo">
            <p v-if="link.descripcion != ''" class="text-muted">{{ link.descripcion }}</p>
          </div>
          <div class="footer">
            <b-button size="sm" variant="danger" class="footer-button" 
              @click.prevent="deleteLink(link.id)">Borrar</b-button>
          </div>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col cols="12">
        <div class="add-more-card"
          :class="{ 'drag-over': isDragOver }"
          @dragover.prevent="onDragOver"
          @dragenter.prevent="onDragEnter" 
          @dragleave="onDragLeave"
          @drop.prevent="onDrop">
          <div class="add-more-content">
            <small class="text-muted">Arrastra</small>
          </div>
        </div>
      </b-col>
    </b-row> -->

    <br v-if="!tieneImagenes">
    <b-row v-if="!tieneImagenes">
      <b-col cols="12">
        <label class="text-muted">Adjuntar archivos o links de referencia, bocetos, etc</label>
      </b-col>
    </b-row>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="pdfModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen modalPDF">
      <app-pdf-modal
        :filename="selectedFilename"
        :url="selectedImageUrl"
        @close="closePDF">
      </app-pdf-modal>  
    </b-modal>

    <b-modal ref="addLinkModal"
        title="Nuevo Link"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-link-add
        @saved = "linkSaved"
        @close = "closeLink">
      </app-link-add>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ImageUploader from '../../components/ImageUploader.vue';
import LinkAdd from './LinkAdd.vue';
import Imagen from  '../shared/imagenModal.vue';
import PdfModal from  '../shared/pdfModal.vue';
import pdf from 'vue-pdf'
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'brief/getField',
  mutationType: 'brief/updateField',
});

export default {
  name: 'BriefImagenesABM',
  components: {
    ImageUploader,
    appLinkAdd: LinkAdd,
    appImagen: Imagen,
    appPdfModal: PdfModal,
    pdf,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal,
    confirmModal
  ],
  data () {
    return {
      labelCols: 2,
      key: 0,
      agregandoImagenes: false,
      selectedFilename: '',
      selectedImageUrl: '',
      isDragOver: false,

      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'success',
      alertMsj: ''
    }
  },
  computed: {
    ...mapFields([
      'imagenes',
      'links'
    ]),
    tieneImagenes() {
      if (this.imagenes) {
        return this.imagenes.length > 0;
      }
      return false;
    }
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    isWord(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'doc') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'docx') {
        return true;
      }

      return false;
    },
    isPowerPoint(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'ppt') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'pptx') {
        return true;
      }

      return false;
    },
    isExcel(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'xls') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'xlsx') {
        return true;
      }

      return false;
    },
    isOtro(fileName) {
      return !this.isImagen(fileName)
        && !this.isPDF(fileName)
        && !this.isWord(fileName)
        && !this.isPowerPoint(fileName)
        && !this.isExcel(fileName);
    },

    agregarImagen() {
      this.agregandoImagenes = true;
    },
    cancelarAgregarImagen() {
      this.agregandoImagenes = false;
    },
    uploadingImage () {
      this.showSpinner();
    },
    setImage(output) {
      var file = this.dataURLtoFile(output.dataUrl, output.info.name);
      
      if (file) {
        this.$store.dispatch('brief/uploadImagen', file)
          .then(() => this.key++)
          .catch(error => this.showErrorMsj(error))
          .finally(() => {
            this.agregandoImagenes = false;
            this.hideSpinner();
          });
      } else {
        this.hideSpinner();
      }
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    setImageNoResize(file) {
      if (file) {
        this.$store.dispatch('brief/uploadImagen', file)
          .then(() => this.key++)
          .catch(error => this.showErrorMsj(error))
          .finally(() => {
            this.agregandoImagenes = false;
            this.hideSpinner();
          });
      } else {
        this.hideSpinner();
      }   
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(file) {
      this.selectedImageUrl = file.url;
      this.selectedFilename = file.fileName;
      this.$refs.pdfModal.show();
    },
    closePDF() {
      this.$refs.pdfModal.hide();
    },
    consultarDocumento(url) {
      window.open(url, '_blank');
    },
    downloadFile(file) {
      if (file.url) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, file.fileName);
          });
      }
    },    
    borrarImagen(imagenId) {
      this.showModalConfirm('¿Desea eliminar el documento seleccionado?', 
        this.borrarImagenSeleccionada.bind(this, imagenId), 'Si', 
        null, 'No');
    },
    borrarImagenSeleccionada(imagenId) {
      this.$store.dispatch('brief/deleteImagen', imagenId)
        .then(() => this.key++)
        .catch(error => this.showErrorMsj(error));
    },

    async copyToClipboard(link) {
      try {
        await navigator.clipboard.writeText(link);

        this.alertMsj = "Se copió el link al portapapeles";
        this.alertCountDown = 3;
        this.showAlert();

        // console.log('Content copied to clipboard');
      } catch (err) {
        this.showErrorMsj(new Error('Esta operación no está permitida'));
        console.error('Failed to copy: ', err);
      }
    },
    addLink() {
      this.$refs.addLinkModal.show();
    },
    linkSaved(link) {
      this.$refs.addLinkModal.hide();
      if (link) {
        this.$store.dispatch('brief/addLink', link)
          .catch(error => this.showErrorMsj(error))
      }
    },
    closeLink() {
      this.$refs.addLinkModal.hide();
    },
    deleteLink(linkId) {
      this.showModalConfirm('Desea eliminar el link seleccionado?', 
        this.deleteLinkSeleccionado.bind(this, linkId), 'Si', null, 'No');
    },
    deleteLinkSeleccionado(linkId) {
      this.$store.dispatch('brief/deleteLink', linkId)
        .catch(error => this.showErrorMsj(error))
    },

    onDragOver(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDragOver = true;
    },
    onDragEnter(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDragOver = true;
    },
    onDragLeave(event) {
      event.preventDefault();
      event.stopPropagation();
      // Solo quitar el estado si realmente salimos del área
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.isDragOver = false;
      }
    },
    onDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDragOver = false;
      
      const files = Array.from(event.dataTransfer.files);
      
      if (files.length > 0) {
        // console.log(files);
        this.procesarFiles(files);
      }
    },
    procesarFiles(files) {
      this.showSpinner();
      
      files.forEach(file => {
        // Verificar si es una imagen que necesita resize
        const isImagenToResize = this.imagenToResize(file);
        
        if (isImagenToResize) {
          // Usar la lógica de resize del image-uploader
          this.uploadResizedImage(file);
        } else {
          // Subir directamente sin resize
          this.$store.dispatch('brief/uploadImagen', file)
            .then(() => this.key++)
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      });
    },
    imagenToResize(file) {
      const tiposImagenResize = ['image/jpeg', 'image/jpg', 'image/png'];
      return tiposImagenResize.includes(file.type);
    },
    uploadResizedImage(file) {
      // Crear un FileReader para convertir a dataURL y aplicar resize
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          // Aplicar la misma lógica de resize que usa image-uploader
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          // Calcular nuevas dimensiones (misma lógica que image-uploader)
          let { width, height } = this.calcularDimensiones(img.width, img.height);
          
          canvas.width = width;
          canvas.height = height;
          
          // Dibujar imagen redimensionada
          ctx.drawImage(img, 0, 0, width, height);
          
          // Convertir a blob y subir
          canvas.toBlob((blob) => {
            const resizedFile = new File([blob], file.name, { type: file.type });
            this.$store.dispatch('brief/uploadImagen', resizedFile)
              .then(() => this.key++)
              .catch(error => this.showErrorMsj(error))
              .finally(() => this.hideSpinner());
          }, file.type, 0.7); // Misma calidad que image-uploader
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    calcularDimensiones(originalWidth, originalHeight) {
      const maxWidth = 1024;
      const maxHeight = 2048;
      
      let width = originalWidth;
      let height = originalHeight;
      
      // Aplicar la misma lógica de redimensionamiento que image-uploader
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }
      if (height > maxHeight) {
        width = (width * maxHeight) / height;
        height = maxHeight;
      }
      
      return { width, height };
    },    
  },
}
</script>

<style>
  .brief-card-header .card-body {
    padding: 0;
  }
  .brief-card-header .card-body > div {
    padding: 20px;
  }

  .brief-abm .galeria-imagenes {
    position: relative;
    min-height: 300px;
  }
  
  .brief-abm .galeria-imagenes .galeria-imagen {
    border: none;
    /* padding-top: 20px; */
    text-align: center;
  }
  .brief-abm .galeria-imagenes .galeria-imagen .card-body {
    padding: 0;
  }
  .brief-abm .galeria-imagenes .galeria-imagen img {
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .brief-abm .galeria-imagenes .galeria-imagen .footer {
    height: 40px;
    display: inline-block;
    width: 100%;
  }
  .brief-abm .galeria-imagenes .galeria-imagen .footer button {
    display: none;
    margin-right: 0;
    width: 100%;
  }
  .brief-abm .galeria-imagenes .galeria-imagen:hover .footer button {
    display: inline-block;
  }
  @media(max-width:766px){
    .brief-abm .galeria-imagenes .galeria-imagen .footer button {
      display: inline-block;
    }
  }

  /* .brief-abm .galeria-imagenes .galeria-imagen, */
  .brief-abm .galeria-imagenes .galeria-pdf {
    max-height: 160px !important;
    overflow: hidden;
  }
  .brief-abm .galeria-imagenes .galeria-pdf > div {
    cursor: pointer;
  }

  .brief-abm .galeria-imagenes .galeria-doc {
    display: block;
  }
  .brief-abm .galeria-imagenes .galeria-doc i,
  .brief-abm .galeria-imagenes .galeria-doc label {
    display: block;
    cursor: pointer;
  }
  .brief-abm .galeria-imagenes .galeria-doc i {
    color: rgb(20,76,129);
    margin-bottom: 10px;
  }
  .brief-abm .galeria-imagenes .galeria-doc label {
    margin-bottom: 20px;
  }

  .brief-abm .galeria-imagenes .subtitulo,
  .brief-abm .galeria-imagenes .subtitulo label,
  .brief-abm .galeria-imagenes .subtitulo button {
    display: inline-block !important;
  }

  .brief-abm .galeria-imagenes #add-imagen {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-abm .galeria-imagenes #add-imagen:hover {
    color: #1b8eb7;
  }


  .brief-abm .galeria-imagenes .dropdown-menu li {
    list-style: none !important;
  }
  .brief-abm .galeria-imagenes .titulo p {
    font-size: 0.8em;
  }

  .brief-abm .galeria-imagenes .drag-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px dashed rgba(0, 123, 255, 1);
    background-color: rgba(0, 123, 255, 0.60);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999;
    border-radius: 0.25rem;
  }

  .brief-abm .galeria-imagenes .drag-overlay i {
    margin-bottom: 10px;
  }

  .brief-abm .galeria-imagenes .drag-overlay p {
    margin: 0;
    font-weight: bold;
  }

</style>
